export const isMobile = () => {
  if (window.innerWidth > 770) {
    return false;
  }
  return Boolean(navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
    || window.innerWidth <= 769);
};

const DeviceDetectorService = {
  isMobile,
};

export default DeviceDetectorService;
